import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = {
  key: 0,
  class: "login_user_badge pa-1 ml-1 body-2 bg-light-blue-lighten-2 text-white"
}
const _hoisted_5 = {
  key: 0,
  class: "badge d-flex justify-center align-center mr-2"
}
const _hoisted_6 = { class: "px-5 py-2" }
const _hoisted_7 = { class: "badge d-flex justify-center align-center mr-2" }
const _hoisted_8 = { class: "px-5 py-2" }
const _hoisted_9 = { class: "badge d-flex justify-center align-center mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        class: "position-relative"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: "",
            variant: "text"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            class: "flex-grow-1 text-center ml-0",
            style: {"pointer-events":"none"}
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" 家族設定 ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            disabled: "",
            style: {"visibility":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "pa-1 today-wrapper" }, [
      _createElementVNode("h5", null, "保護者")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_v_list, {
        lines: "two",
        density: "compact"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (p, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: p.parentId
            }, [
              _createVNode(_component_v_list_item, {
                onClick: ($event: any) => (_ctx.toParent('/parent/edit', 'ParentEdit', p.isLoginUser))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, { class: "ml-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: p.imageUrl ?? undefined
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                append: _withCtx(() => [
                  (p.isLoginUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(p.lastName + p.firstName), 1),
                        (p.isLoginUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " あなた "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_list_item_subtitle, { class: "subtitle-2 text-grey-darken-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatParentType(p.parentType)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_v_divider)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.to('/parent/add', 'ParentAdd'))),
        color: "primary",
        variant: "outlined",
        block: "",
        small: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createTextVNode(" 他の保護者を招待する ", -1))
        ]),
        _: 1
      })
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "pa-1 today-wrapper" }, [
      _createElementVNode("h5", null, "お子さま")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_v_list, {
        lines: "two",
        density: "compact"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: c.childId
            }, [
              _createVNode(_component_v_list_item, {
                onClick: ($event: any) => (_ctx.toChild('/child/edit', 'ChildEdit', c.childId, c.lastName + c.firstName))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, { class: "ml-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: c.imageUrl ?? undefined
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                append: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(c.lastName + c.firstName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_v_divider)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_btn, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.to('/child/add', 'ChildAdd'))),
        color: "primary",
        variant: "outlined",
        block: "",
        small: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createTextVNode(" お子さまを追加する ", -1))
        ]),
        _: 1
      })
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "pa-1 today-wrapper" }, [
      _createElementVNode("h5", null, "家族情報")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_v_list, {
        lines: "two",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.to('/family/edit', 'FamilyEdit')))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_avatar, { class: "ml-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, { src: "https://via.placeholder.com/240x180?text=Sample+Image+1" })
                ]),
                _: 1
              })
            ]),
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.family?.familyName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider)
        ]),
        _: 1
      })
    ])
  ]))
}